export const rules = [

    // ✅ 1. Non permanent resident
    {
        name: 'Non permanent resident',

        condition: (claim) => {

            if (!claim || !claim.claimantDetails) return false;

            return claim.claimantDetails.ukResident === false;
        },

        result: {
            statusName: 'POLICY_VOIDED',
            reasonCode: 'VOID-RES'
        }
    },

    // ✅ 2. SIM missing on phone
    {
        name: 'Phone without SIM in device',

        condition: (claim) => {

            if (!claim || !claim.gadgetDetails) return false;

            return claim.gadgetDetails.some(g =>
                g.typeId === 1 &&
                g.simInDevice === false
            );
        },

        result: {
            statusName: 'DECLINED',
            reasonCode: 'DEC-NC-SIM'
        }
    },


    //// ✅ 2. Proof of usage missing (from pipeline)
    //{
    //    name: 'Missing proof of usage',

    //    condition: (claim) => {
    //        const runs = claim.pipelineRunHistoryDetails || [];

    //        return runs.some(run => {
    //            try {
    //                const results = JSON.parse(run.result || '[]');

    //                return results.some(r =>
    //                    r.RuleName === 'TigaUploadedProofOfUsage' &&
    //                    r.StatusText === 'FAILED'
    //                );
    //            } catch (e) {
    //                return false;
    //            }
    //        });
    //    },

    //    result: {
    //        statusName: 'DECLINED',
    //        reasonCode: 'DEC-NC-USG'
    //    }
    //},


    //// ✅ 3. Fraud flag
    //{
    //    name: 'Fraud detected',

    //    condition: (claim) => {
    //        const runs = claim.pipelineRunHistoryDetails || [];

    //        return runs.some(run => {
    //            try {
    //                const results = JSON.parse(run.result || '[]');

    //                return results.some(r =>
    //                    r.RuleName === 'DEC-FRA' ||
    //                    (r.RuleName === 'Fraud' && r.StatusText === 'FAILED')
    //                );
    //            } catch {
    //                return false;
    //            }
    //        });
    //    },

    //    result: {
    //        statusName: 'DECLINED',
    //        reasonCode: 'DEC-FRA'
    //    }
    //}

];

//export const rules = [

//    {
//        name: 'Phone without SIM',

//        condition: (claim) => {
//            return claim.hasPhone === true &&
//                claim.simInDevice === false;
//        },

//        result: {
//            statusName: 'DECLINED',
//            reasonCode: 'DEC-NC-SIM'
//        }
//    }

//];

export function evaluateClaim(claim, { statuses, reasons }) {
    console.log('-evaluateClaim: ', claim.claimId)
    for (const rule of rules) {

        if (rule.condition(claim)) {

            const status = statuses.find(
                s => s.name === rule.result.statusName
            );

            const reason = reasons.find(
                r => r.code.trim() === rule.result.reasonCode
            );

            if (!status) continue;

            return {
                suggested: true,
                statusId: status.id,
                reasonId: reason ? reason.id : null,
                ruleName: rule.name
            };
        }
    }

    return null;
}
